var A = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, b = function(t) {
  return typeof t == "string" ? t.length > 0 : typeof t == "number";
}, u = function(t, e, r) {
  return e === void 0 && (e = 0), r === void 0 && (r = Math.pow(10, e)), Math.round(r * t) / r + 0;
}, s = function(t, e, r) {
  return e === void 0 && (e = 0), r === void 0 && (r = 1), t > r ? r : t > e ? t : e;
}, E = function(t) {
  return (t = isFinite(t) ? t % 360 : 0) > 0 ? t : t + 360;
}, H = function(t) {
  return { r: s(t.r, 0, 255), g: s(t.g, 0, 255), b: s(t.b, 0, 255), a: s(t.a) };
}, p = function(t) {
  return { r: u(t.r), g: u(t.g), b: u(t.b), a: u(t.a, 3) };
}, B = /^#([0-9a-f]{3,8})$/i, c = function(t) {
  var e = t.toString(16);
  return e.length < 2 ? "0" + e : e;
}, F = function(t) {
  var e = t.r, r = t.g, a = t.b, n = t.a, f = Math.max(e, r, a), o = f - Math.min(e, r, a), i = o ? f === e ? (r - a) / o : f === r ? 2 + (a - e) / o : 4 + (e - r) / o : 0;
  return { h: 60 * (i < 0 ? i + 6 : i), s: f ? o / f * 100 : 0, v: f / 255 * 100, a: n };
}, P = function(t) {
  var e = t.h, r = t.s, a = t.v, n = t.a;
  e = e / 360 * 6, r /= 100, a /= 100;
  var f = Math.floor(e), o = a * (1 - r), i = a * (1 - (e - f) * r), l = a * (1 - (1 - e + f) * r), h = f % 6;
  return { r: 255 * [a, i, o, o, l, a][h], g: 255 * [l, a, a, i, o, o][h], b: 255 * [o, o, l, a, a, i][h], a: n };
}, I = function(t) {
  return { h: E(t.h), s: s(t.s, 0, 100), l: s(t.l, 0, 100), a: s(t.a) };
}, $ = function(t) {
  return { h: u(t.h), s: u(t.s), l: u(t.l), a: u(t.a, 3) };
}, j = function(t) {
  return P((r = (e = t).s, { h: e.h, s: (r *= ((a = e.l) < 50 ? a : 100 - a) / 100) > 0 ? 2 * r / (a + r) * 100 : 0, v: a + r, a: e.a }));
  var e, r, a;
}, g = function(t) {
  return { h: (e = F(t)).h, s: (n = (200 - (r = e.s)) * (a = e.v) / 100) > 0 && n < 200 ? r * a / 100 / (n <= 100 ? n : 200 - n) * 100 : 0, l: n / 2, a: e.a };
  var e, r, a, n;
}, D = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, O = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, V = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, G = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y = { string: [[function(t) {
  var e = B.exec(t);
  return e ? (t = e[1]).length <= 4 ? { r: parseInt(t[0] + t[0], 16), g: parseInt(t[1] + t[1], 16), b: parseInt(t[2] + t[2], 16), a: t.length === 4 ? u(parseInt(t[3] + t[3], 16) / 255, 2) : 1 } : t.length === 6 || t.length === 8 ? { r: parseInt(t.substr(0, 2), 16), g: parseInt(t.substr(2, 2), 16), b: parseInt(t.substr(4, 2), 16), a: t.length === 8 ? u(parseInt(t.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(t) {
  var e = V.exec(t) || G.exec(t);
  return e ? e[2] !== e[4] || e[4] !== e[6] ? null : H({ r: Number(e[1]) / (e[2] ? 100 / 255 : 1), g: Number(e[3]) / (e[4] ? 100 / 255 : 1), b: Number(e[5]) / (e[6] ? 100 / 255 : 1), a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t) {
  var e = D.exec(t) || O.exec(t);
  if (!e)
    return null;
  var r, a, n = I({ h: (r = e[1], a = e[2], a === void 0 && (a = "deg"), Number(r) * (A[a] || 1)), s: Number(e[3]), l: Number(e[4]), a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1) });
  return j(n);
}, "hsl"]], object: [[function(t) {
  var e = t.r, r = t.g, a = t.b, n = t.a, f = n === void 0 ? 1 : n;
  return b(e) && b(r) && b(a) ? H({ r: Number(e), g: Number(r), b: Number(a), a: Number(f) }) : null;
}, "rgb"], [function(t) {
  var e = t.h, r = t.s, a = t.l, n = t.a, f = n === void 0 ? 1 : n;
  if (!b(e) || !b(r) || !b(a))
    return null;
  var o = I({ h: Number(e), s: Number(r), l: Number(a), a: Number(f) });
  return j(o);
}, "hsl"], [function(t) {
  var e = t.h, r = t.s, a = t.v, n = t.a, f = n === void 0 ? 1 : n;
  if (!b(e) || !b(r) || !b(a))
    return null;
  var o = function(i) {
    return { h: E(i.h), s: s(i.s, 0, 100), v: s(i.v, 0, 100), a: s(i.a) };
  }({ h: Number(e), s: Number(r), v: Number(a), a: Number(f) });
  return P(o);
}, "hsv"]] }, R = function(t, e) {
  for (var r = 0; r < e.length; r++) {
    var a = e[r][0](t);
    if (a)
      return [a, e[r][1]];
  }
  return [null, void 0];
}, J = function(t) {
  return typeof t == "string" ? R(t.trim(), y.string) : typeof t == "object" && t !== null ? R(t, y.object) : [null, void 0];
}, v = function(t, e) {
  var r = g(t);
  return { h: r.h, s: s(r.s + 100 * e, 0, 100), l: r.l, a: r.a };
}, m = function(t) {
  return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3 / 255;
}, C = function(t, e) {
  var r = g(t);
  return { h: r.h, s: r.s, l: s(r.l + 100 * e, 0, 100), a: r.a };
}, k = function() {
  function t(e) {
    this.parsed = J(e)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return t.prototype.isValid = function() {
    return this.parsed !== null;
  }, t.prototype.brightness = function() {
    return u(m(this.rgba), 2);
  }, t.prototype.isDark = function() {
    return m(this.rgba) < 0.5;
  }, t.prototype.isLight = function() {
    return m(this.rgba) >= 0.5;
  }, t.prototype.toHex = function() {
    return e = p(this.rgba), r = e.r, a = e.g, n = e.b, o = (f = e.a) < 1 ? c(u(255 * f)) : "", "#" + c(r) + c(a) + c(n) + o;
    var e, r, a, n, f, o;
  }, t.prototype.toRgb = function() {
    return p(this.rgba);
  }, t.prototype.toRgbString = function() {
    return e = p(this.rgba), r = e.r, a = e.g, n = e.b, (f = e.a) < 1 ? "rgba(" + r + ", " + a + ", " + n + ", " + f + ")" : "rgb(" + r + ", " + a + ", " + n + ")";
    var e, r, a, n, f;
  }, t.prototype.toHsl = function() {
    return $(g(this.rgba));
  }, t.prototype.toHslString = function() {
    return e = $(g(this.rgba)), r = e.h, a = e.s, n = e.l, (f = e.a) < 1 ? "hsla(" + r + ", " + a + "%, " + n + "%, " + f + ")" : "hsl(" + r + ", " + a + "%, " + n + "%)";
    var e, r, a, n, f;
  }, t.prototype.toHsv = function() {
    return e = F(this.rgba), { h: u(e.h), s: u(e.s), v: u(e.v), a: u(e.a, 3) };
    var e;
  }, t.prototype.invert = function() {
    return d({ r: 255 - (e = this.rgba).r, g: 255 - e.g, b: 255 - e.b, a: e.a });
    var e;
  }, t.prototype.saturate = function(e) {
    return e === void 0 && (e = 0.1), d(v(this.rgba, e));
  }, t.prototype.desaturate = function(e) {
    return e === void 0 && (e = 0.1), d(v(this.rgba, -e));
  }, t.prototype.grayscale = function() {
    return d(v(this.rgba, -1));
  }, t.prototype.lighten = function(e) {
    return e === void 0 && (e = 0.1), d(C(this.rgba, e));
  }, t.prototype.darken = function(e) {
    return e === void 0 && (e = 0.1), d(C(this.rgba, -e));
  }, t.prototype.rotate = function(e) {
    return e === void 0 && (e = 15), this.hue(this.hue() + e);
  }, t.prototype.alpha = function(e) {
    return typeof e == "number" ? d({ r: (r = this.rgba).r, g: r.g, b: r.b, a: e }) : u(this.rgba.a, 3);
    var r;
  }, t.prototype.hue = function(e) {
    var r = g(this.rgba);
    return typeof e == "number" ? d({ h: e, s: r.s, l: r.l, a: r.a }) : u(r.h);
  }, t.prototype.isEqual = function(e) {
    return this.toHex() === d(e).toHex();
  }, t;
}(), d = function(t) {
  return t instanceof k ? t : new k(t);
}, L = [], K = function(t) {
  t.forEach(function(e) {
    L.indexOf(e) < 0 && (e(k, y), L.push(e));
  });
};
function Q(t, e) {
  var r = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, a = {};
  for (var n in r)
    a[r[n]] = n;
  var f = {};
  t.prototype.toName = function(o) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b))
      return "transparent";
    var i, l, h = a[this.toHex()];
    if (h)
      return h;
    if (o != null && o.closest) {
      var z = this.toRgb(), w = 1 / 0, N = "black";
      if (!f.length)
        for (var x in r)
          f[x] = new t(r[x]).toRgb();
      for (var q in r) {
        var M = (i = z, l = f[q], Math.pow(i.r - l.r, 2) + Math.pow(i.g - l.g, 2) + Math.pow(i.b - l.b, 2));
        M < w && (w = M, N = q);
      }
      return N;
    }
  }, e.string.push([function(o) {
    var i = o.toLowerCase(), l = i === "transparent" ? "#0000" : r[i];
    return l ? new t(l).toRgb() : null;
  }, "name"]);
}
K([Q]);
function S(t) {
  let e = d(t).toHsl();
  return {
    hue: e.h,
    saturation: e.s,
    lightness: e.l,
    alpha: e.a,
    authored: t
  };
}
function T(t, e) {
  let r = S(t), a = S(e);
  return (r.saturation === 0 || a.saturation === 0) && r.saturation !== a.saturation ? a.saturation - r.saturation : r.hue !== a.hue ? r.hue - a.hue : r.saturation !== a.saturation ? r.saturation - a.saturation : r.saturation === 0 && a.saturation === 0 && r.lightness !== a.lightness ? a.lightness - r.lightness : r.alpha === a.alpha ? r.authored.toLowerCase().localeCompare(a.authored.toLowerCase()) : a.alpha - r.alpha;
}
function U(t) {
  return t.sort(T);
}
export {
  S as convert,
  U as sort,
  T as sortFn
};
